module.exports = __webpack_public_path__ + "img/daily-footer.07ff3e1c.png";